import { render, staticRenderFns } from "./ListaSubcategorias.vue?vue&type=template&id=506765ef"
import script from "./ListaSubcategorias.vue?vue&type=script&lang=js"
export * from "./ListaSubcategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports